class AnnouncementBarRotator extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.slideCount = this.slides.length;
    this.index = 0;
    this.timer = null;
    this.paused = false;
    this.reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    this.interval =
      (parseInt(this.dataset.interval, 10) || 5) * 1000;
    this.duration = parseInt(this.dataset.duration, 10) || 500;
    this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
    this.direction = this.dataset.direction || '';

    if (this.track) {
      this.track.style.transition = `transform ${this.duration}ms ease-in-out`;
    }

    this.updateTransform();
    this.bindEvents();

    if (this.slideCount > 1 && !this.reducedMotion) {
      this.startTimer();
    }
  }

  disconnectedCallback() {
    this.stopTimer();
    this.unbindEvents();
  }

  bindEvents() {
    this.onMouseEnter = () => {
      if (this.pauseOnHover) this.pause();
    };
    this.onMouseLeave = () => {
      if (this.pauseOnHover && !this.paused) this.startTimer();
    };
    this.onBlockSelect = (event) => {
      const slide = event.target.closest('[data-slide]');
      if (!slide || !this.contains(slide)) return;
      this.goToSlide(slide);
      this.pause();
    };
    this.onBlockDeselect = () => {
      if (!this.reducedMotion && this.slideCount > 1) {
        this.paused = false;
        this.startTimer();
      }
    };

    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }

    document.addEventListener('shopify:block:select', this.onBlockSelect);
    document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
  }

  unbindEvents() {
    if (this.pauseOnHover) {
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
    }

    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
  }

  startTimer() {
    this.stopTimer();
    this.timer = window.setInterval(() => this.advance(), this.interval);
  }

  stopTimer() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  pause() {
    this.paused = true;
    this.stopTimer();
  }

  advance() {
    if (this.direction === 'reverse') {
      this.index = (this.index - 1 + this.slideCount) % this.slideCount;
    } else {
      this.index = (this.index + 1) % this.slideCount;
    }
    this.updateTransform();
  }

  updateTransform() {
    if (!this.track) return;
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
  }

  goToSlide(slideEl) {
    const slideIndex = this.slides.indexOf(slideEl);
    if (slideIndex === -1) return;
    this.index = slideIndex;
    this.updateTransform();
  }
}

if (!customElements.get('announcement-bar-rotator')) {
  customElements.define('announcement-bar-rotator', AnnouncementBarRotator);
}
